module.exports = __webpack_public_path__ + "static/media/representacionfemenina_780.23a0a24a.jpg";